import { createLegacyIssueInteraction } from './createLegacyIssueInteraction.tsx';

export const legacyIssueCreateCombinedInteraction: ReturnType<typeof createLegacyIssueInteraction> =
	createLegacyIssueInteraction('legacy-issue-create.combined');
